"use client";
import { Button } from "antd";
import { MailOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslations } from "next-intl";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";
import Image from "next/image";
import { contactInfo } from "@/lib/contacts";
import { ChatCircleText } from "@phosphor-icons/react/dist/ssr";
const ContactBox = () => {
	const t = useTranslations();
	const { openModalInquiry } = useModalInquiryContext();
	return (
		<>
			<div
				className="flex gap-4 rounded-t-md px-[19px] py-4 "
				style={{
					backgroundImage: "linear-gradient(90deg, #eaeff5 0%,  #fbfcfd 100%)",
				}}
			>
				<Image
					src="/image/logo.png"
					width={100}
					height={80}
					alt="longshengmfg-logo"
					className="object-cover max-md:h-12 max-md:w-12"
				></Image>
				<span className="font-bold">{contactInfo.name}</span>
			</div>

			<div className="flex h-fit flex-col gap-4 px-7 pb-6 pt-24 font-bold">
				<Button
					onClick={openModalInquiry}
					shape="round"
					type="primary"
					size="large"
					className="w-full !border-black !bg-black hover:!bg-white hover:!text-black"
				>
					<MailOutlined />
					{t("base.contact-supplier")}
				</Button>
				<Button
					onClick={openModalInquiry}
					shape="round"
					size="large"
					className="w-full !border-black !text-black hover:!bg-black hover:!text-white"
				>
					<ChatCircleText size={16} weight="bold" />
					{t("base.chat")}
				</Button>
			</div>
		</>
	);
};
export default ContactBox;
